import { rowsPerPage } from '../../pages/constants';
import { httpRequest } from '../../shared/lib/utils/httpClient';

export interface CategoryType {
  id: number;
  name: string;
}

export interface ContactUsType {
  id?: number;
  firstName: string;
  lastName: string;
  suffix: string;
  title: string;
  department: string;
  primaryEmail: string;
  otherEmail: string;
  primaryPhone: string;
  mobilePhone: string;
  otherPhone: string;
  categoryId?: number | string;
  notes: string;
  category?: string;
}

export interface ContactUsAllResponse {
  id?: number;
  name: string;
  title: string;
  department: string;
  primaryEmail: string;
  primaryPhone: string;
  category: string;
  firstName?: string;
  lastName?: string;
  suffix?: string;
  mobilePhone?: string;
  otherPhone?: string;
  otherEmail?: string;
  notes?: string;
}

export interface ContactUsGetAllResponse {
  contactsList: ContactUsAllResponse[];
  currentPage: number;
  pageSize: number;
  totalPages: number;
  totalRecords: number;
}

export interface ContactUsMetaData {
  categoryList: CategoryType[];
}

export const getContactUsMetaData = async (
  userId: string
): Promise<ContactUsMetaData> => {
  const response = await httpRequest<ContactUsMetaData>({
    method: 'GET',
    url: `operation/facility/contacts/metadata`,
    headers: { userId },
  });
  return response;
};

export const saveOrUpdateContact = async (
  userId: string,
  action: string,
  facilityId: string,
  payload: ContactUsType
) => {
  const apiAction = action === 'Save' ? 'SAVE' : 'UPDATE';
  const response = await httpRequest<ContactUsType>({
    method: 'PUT',
    url: `/operation/facility/${facilityId}/contacts?action=${apiAction}`,
    headers: { userId },
    data: payload,
  });
  return response;
};

export const getContactUsAllData = async (
  userId: string,
  facilityId: string,
  page: number = 0,
  size: number = rowsPerPage,
  sortField?: string,
  sortType?: string
): Promise<ContactUsGetAllResponse> => {
  const params: Record<string, string | number> = {
    page,
    size,
  };
  if (sortField) params.sortField = sortField;
  if (sortType) params.sortType = sortType;
  const response = await httpRequest<ContactUsGetAllResponse>({
    method: 'GET',
    url: `operation/facility/${facilityId}/contacts`,
    params,
    headers: { userId },
  });
  return response;
};

export const getContactDetailsById = async (
  userId: string,
  contactId: number
): Promise<ContactUsType> => {
  const response = await httpRequest<ContactUsType>({
    method: 'GET',
    url: `/operation/facility/contacts/edit/${contactId}`,
    headers: { userId },
  });
  return response;
};

export const deleteContact = async (
  userId: string,
  contactId: number
): Promise<ContactUsType> => {
  const response = await httpRequest<ContactUsType>({
    method: 'DELETE',
    url: `/operation/facility/contacts/${contactId}/delete`,
    headers: { userId },
  });
  return response;
};

export const getContactViewDetailsById = async (
  userId: string,
  contactId: number
): Promise<ContactUsAllResponse> => {
  const response = await httpRequest<ContactUsAllResponse>({
    method: 'GET',
    url: `/operation/facility/contacts/view/${contactId}`,
    headers: { userId },
  });
  return response;
};
